//Replicate for stage and prod
export const environment = {
  production: false,
  environment: 'dev',
  title: 'Sierra Order',
  name: 'sierra-order',
  featureFlags: {
    receipts: true,
  },
  proxyUrls: {
    assetApi: 'https://asset.api.dev.sierra-erp.com',
    itemApi: 'https://item.api.dev.sierra-erp.com',
    userMasterApi: 'https://user.api.dev.sierra-erp.com',
    inventoryApi: 'https://inventory.api.dev.sierra-erp.com',
    orderApi: 'https://order.api.dev.sierra-erp.com',
    financeApi: 'https://finance.api.dev.sierra-erp.com',
    reportApi: 'https://reportgenerator.dev.sierra-erp.com',
  },
  externalSitesUrls: {
    itemModule: 'sierra.textiles.come',
  },
};
